import React, { useEffect } from 'react';
import { Header } from '../layouts/main/header';
import { Hero } from './hero';
import { Timeline } from './timeline';
import { RightBanner } from './rightBanner';
import { Speakers } from './speakers';
import { LeftBanner } from './leftBanner';
import { LiveBanner } from './liveBanner';
import Footer from './footer';
import { IPlaylistItem } from '../interfaces/youtube';
import { getPlaylistItems, getVideoDetails } from '../utils/apiClient';
import { RegisterFormDialog } from '../layouts/main/registerFormDialog';

export const Main: React.FC = () => {
  const [playlistItems, setPlaylistItems] = React.useState<IPlaylistItem[]>([]);
  const [mostRecentPlaylistItem, setMostRecentPlaylistItem] = React.useState<IPlaylistItem>(
    {} as IPlaylistItem
  );
  const [liveStreamingDetails, setLiveStreamingDetails] = React.useState<{
    actualStartTime: string;
    actualEndTime: string;
    scheduledStartTime: string;
  }>({ actualStartTime: '', actualEndTime: '', scheduledStartTime: '' });

  const [openRegisterRequestForm, setOpenRegisterRequestForm] = React.useState<boolean>(false);

  const handleCloseDialog = () => {
    setOpenRegisterRequestForm(false);
  };

  useEffect(() => {
    const init = async () => {
      const playlistData = await getPlaylistItems();

      if (playlistData && playlistData.items) {
        const mostRecentItem = playlistData.items[0];
        setPlaylistItems(playlistData.items);
        setMostRecentPlaylistItem(playlistData.items[0]);

        // get most recent video details
        const videoDetails = await getVideoDetails(mostRecentItem.contentDetails.videoId ?? '');
        const liveStreamingDetails =
          videoDetails && videoDetails.items && videoDetails.items.length > 0
            ? videoDetails.items[0].liveStreamingDetails
            : { actualStartTime: '', actualEndTime: '', scheduledStartTime: '' };

        setLiveStreamingDetails(liveStreamingDetails);
      }
    };

    init();
  }, []);

  const today = Date.now();
  const futureTime = new Date(liveStreamingDetails.scheduledStartTime).getTime();
  const isLiveEvent = futureTime > today;

  return (
    <Header isLiveEvent={isLiveEvent} setOpenDialog={setOpenRegisterRequestForm}>
      <div className="grid grid-cols gap-10">
        <div id="about">
          <Hero
            playlistItem={mostRecentPlaylistItem}
            isLiveEvent={isLiveEvent}
            setOpenDialog={setOpenRegisterRequestForm}
          />
        </div>

        <div id="schedule">
          {liveStreamingDetails && (
            <Timeline
              liveStreamingDetails={liveStreamingDetails}
              isLiveEvent={isLiveEvent}
              setOpenDialog={setOpenRegisterRequestForm}
            />
          )}
        </div>

        <div>
          <RightBanner />
        </div>

        <div id="speakers">
          <Speakers />
        </div>

        <div>
          <LeftBanner />
        </div>

        <div>
          <LiveBanner isLiveEvent={isLiveEvent} setOpenDialog={setOpenRegisterRequestForm} />
        </div>

        <div>
          <Footer />
        </div>
      </div>
      <RegisterFormDialog
        open={openRegisterRequestForm}
        setOpen={setOpenRegisterRequestForm}
        videoId={mostRecentPlaylistItem?.contentDetails?.videoId}
        closeDialog={handleCloseDialog}
        isLiveEvent={isLiveEvent}
      />
    </Header>
  );
};
